module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Beinwil_am_See-f7e2291c0bf49906076002c85565e474.svg";